import { useEffect, useRef, useState } from 'react';

// The Google/Apple pair, shared by the front page's signup box
// (FreeAccountBox) and step 1 of the /sign-up wizard (AccountDetailsStep) -
// one component rather than two copies, since the two are the same entry
// point into the same flow and should never drift apart visually.
//
// TODO(social-sign-on): neither provider is configured in services/auth
// (auth.js has no socialProviders block and there are no OAuth client
// credentials anywhere in this system), so the pair is hidden outright
// rather than rendered as a "Coming soon" tease. The placement and wording
// are the ones we want - the flag is the single switch that brings them
// back once authClient.signIn.social({provider}) has credentials to use,
// and BOTH call sites gate their own "or ..." divider on it too, since a
// divider separating a form from nothing is worse than no divider at all.
export const SOCIAL_SIGN_ON_ENABLED = false;

const COMING_SOON_MS = 1800;

function GoogleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z" />
      <path fill="#FBBC05" d="M3.964 10.706A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.997 8.997 0 000 9c0 1.452.348 2.827.957 4.038l3.007-2.332z" />
      <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.581C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.962L3.964 7.294C4.672 5.167 6.656 3.58 9 3.58z" />
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 384 512" fill="currentColor" aria-hidden="true">
      <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.3-41.7-84.7-44.6-35.4-2.8-74.1 20.6-88.3 20.6-15 0-49.4-19.5-76.4-19.5C63.3 141 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z" />
    </svg>
  );
}

export default function SocialButtons() {
  const [comingSoon, setComingSoon] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  function showComingSoon() {
    clearTimeout(timer.current);
    setComingSoon(true);
    timer.current = setTimeout(() => setComingSoon(false), COMING_SOON_MS);
  }

  const buttonClass =
    'inline-flex items-center justify-center gap-2 px-2.5 py-2.5 bg-ink-900 border border-ink-700 rounded-lg text-paper font-display font-medium text-[13px] hover:bg-ink-800 transition-colors';

  return (
    <div>
      <div className="grid grid-cols-2 gap-3">
        <button type="button" onClick={showComingSoon} className={buttonClass}>
          <GoogleIcon />
          Google
        </button>
        <button type="button" onClick={showComingSoon} className={buttonClass}>
          <AppleIcon />
          Apple
        </button>
      </div>
      {comingSoon && <p className="mt-2 text-center text-xs text-ink-500">Coming soon!</p>}
    </div>
  );
}
